import {
  BookOpen,
  MapPin,
  GraduationCap,
  Pill,
  TestTubes,
  Gift,
  Syringe,
  Stethoscope,
  FileText,
  ClipboardList,
  HeartPulse,
  Activity,
} from "lucide-react-native";
import type { LucideIcon } from "lucide-react-native";
import { EMBER } from "../../../onboarding/theme";
import { semanticColors } from "@louise/theme/tokens";

export type SearchCategory =
  | "articles"
  | "clinics"
  | "programs"
  | "supplements"
  | "tests"
  | "grants"
  | "medications"
  | "providers"
  | "documents"
  | "conditions"
  | "procedures"
  | "therapies";

export type SearchItemImage =
  | { type: "uri"; uri: string }
  | { type: "require"; source: number }
  | { type: "initials"; initials: string; bgColor: string };

export type SearchItem = {
  id: string;
  category: SearchCategory;
  title: string;
  subtitle?: string;
  keywords?: string;
  /** Optional image to display instead of the category icon */
  image?: SearchItemImage;
  navTarget?: {
    tab: string;
    screen: string;
    params?: Record<string, unknown>;
  };
};

export type CategoryConfig = {
  label: string;
  icon: LucideIcon;
  color: string;
  /** Lower = more important. Used as tiebreaker when match scores are equal. */
  priority: number;
};

export const CATEGORY_CONFIG: Record<SearchCategory, CategoryConfig> = {
  articles: {
    label: "Articles",
    icon: BookOpen,
    color: "#B08030",
    priority: 1,
  },
  medications: {
    label: "Medications",
    icon: Syringe,
    color: "#38BDF8",
    priority: 2,
  },
  providers: {
    label: "Care Team",
    icon: Stethoscope,
    color: "#A8563A",
    priority: 3,
  },
  conditions: {
    label: "Conditions",
    icon: ClipboardList,
    color: semanticColors.accent.default,
    priority: 4,
  },
  tests: {
    label: "Tests",
    icon: TestTubes,
    color: EMBER.colors.blue,
    priority: 5,
  },
  procedures: {
    label: "Procedures",
    icon: Activity,
    color: EMBER.colors.blue,
    priority: 5.5,
  },
  documents: {
    label: "Documents",
    icon: FileText,
    color: semanticColors.text.tertiary,
    priority: 6,
  },
  clinics: { label: "Clinics", icon: MapPin, color: "#A8563A", priority: 7 },
  supplements: {
    label: "Supplements",
    icon: Pill,
    color: "#4E7342",
    priority: 8,
  },
  programs: {
    label: "Programs",
    icon: GraduationCap,
    color: EMBER.colors.teal,
    priority: 9,
  },
  therapies: {
    label: "Therapies",
    icon: HeartPulse,
    color: EMBER.colors.teal,
    priority: 10,
  },
  grants: {
    label: "Grants",
    icon: Gift,
    color: semanticColors.accent.default,
    priority: 11,
  },
};
